var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternRightBottom(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pattern-right-bottom_svg__Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 240 144",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".pattern-right-bottom_svg__st1{fill:#ad78ff}.pattern-right-bottom_svg__st2{fill:#4f25b7}.pattern-right-bottom_svg__st5{fill:#6c36db}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    className: "pattern-right-bottom_svg__st1",
    d: "M240 135c0 5-4 9-9 9h-39V96h48v39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pattern-right-bottom_svg__st2",
    d: "M96 96H48V48h48v48zM48 144H0V96h48v48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 96h48v24H72v24H48V96z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#c193ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 96h-48V72h24V48h24v48z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ad78ff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pattern-right-bottom_svg__st5",
    d: "M240 48h-48l48-48v48zM96 96h48v48c-26.5 0-48-21.5-48-48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pattern-right-bottom_svg__st1",
    d: "M144 0h48v48c-26.5 0-48-21.5-48-48z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternRightBottom);
export default "/_next/static/images/42eb02ade045a98e305294d2c742bbcd.svg";
export { ForwardRef as ReactComponent };